import React from 'react';
import PropTypes from 'prop-types';
import RightPaneContentTabs from '../right-pane/right-pane-content-tabs';

export const CanvasSettingsContentTabs = ( { handleTabChange, tabIndex } ) => {
    const tabData = [
        {
            dataAutomationId: 'canvas-settings-general-tab',
            label: 'General',
        }
    ];

    return (
        <RightPaneContentTabs
            handleTabChange={handleTabChange}
            tabData={tabData}
            tabIndex={tabIndex}
        />
    );
};

CanvasSettingsContentTabs.propTypes = {
    handleTabChange: PropTypes.func.isRequired,
    tabIndex: PropTypes.number.isRequired
};

export default CanvasSettingsContentTabs;
